import { openAlert } from '../actions/alerts';
import {get} from 'lodash';
import appStore from '../app';

export const handleResponseErrors = (error) => {
  const code = get(error, 'response.data.error.code');
  const message = get(error, 'response.data.error.message.message');
  const {store: {dispatch}} = appStore;
  if(code) {
    switch (code) {
      case 429:
        dispatch(openAlert({
          alertType: 'danger',
          message,
          dismissable: true,
          closeInSeconds: 5
        }));
    }
  }
};